import { Link } from "gatsby"
import React from "react"
import ActOnNew from "../components/act-on/act-on-new"
import Layout from "../components/layout"
import "../css/contact.css"
import woman from "../images/WomanSportscoat.png"
import SEO from "../components/seo.js"


const forms = {
  sales: {
    id: "482c542e-14c9-41b6-8bc0-e8bf6cf98243",
    code: (<ActOnNew id="482c542e-14c9-41b6-8bc0-e8bf6cf98243"/>),
    header: "Get in touch with a sales representative",
    tagline: "Our sales team is here to help",
    bullets: [
      "Answer questions",
      "Discuss solutions",
      "Connect you to resources",
      "Demonstrate Project Ares"
    ]
  },
  support: {
    id: "d38bb6e7-355b-45f9-bc09-30488a72d805",
    code: (<ActOnNew id="d38bb6e7-355b-45f9-bc09-30488a72d805"/>),
    header: "Email the Circadence support desk",
    tagline: "Our Support team is here to help",
    bullets: [
      "Share your ideas and suggestions",
      "Contact us about platform issues"
    ]
  }
}

function CheckMark() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.46 22.46" height="15" width="15" style={{marginRight: 5}}>
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <circle cx="11.23" cy="11.23" r="11.23" fill="#4fafe2"/>
          <path fill="#fff" d="M9.35 16.52l-4.7-4.7 1.41-1.41 3.29 3.29 7.05-7.06 1.41 1.42-8.46 8.46z"/>
        </g>
      </g>
    </svg>
  )
}

class ContactPage extends React.Component {

  constructor(props) {
    super(props)
    let form

    try {
      form = (new URL(document.location)).searchParams.get('form');
      if(form != null){
        this.state = {
          form: (forms[form] != null ? forms[form] : forms.sales)
        }

        console.log("getting url props", form);
        return
      }
    } catch {
      form = "sales"
    }

    console.log("Didn't catch any url params");
    this.state = {
      form: forms.sales
    }

  }

  new_form(id) {
    var container = document.getElementById("formBox")
    console.log("new form added");

    return new Promise(function (resolve, reject) {
      var script = document.createElement("script")

      var text =
        ` ! function(o, t, e, a) {
        o._aoForms = o._aoForms || [], o._aoForms.push(a);
        var n = function() {
          var o = t.createElement(e);

          true ? typeof(_aoFormLoader) != "undefined" ? _aoFormLoader.load({
            id: "` +
            id +
            `:d-0001",
            accountId: "36273",
            domain: "marketing.circadence.com",
            isTemp: false,
            noStyle: false,
            prefill: false
          }) : "" : n.insertBefore(o, a)
        };
        window.attachEvent ? window.attachEvent("onload", n) : window.addEventListener("load", n, !1), n()
      }(window, document, "script", {
        id: "` +
            id +
            `",
        accountId: "36273",
        domain: "marketing.circadence.com",
        isTemp: false,
        noStyle: false,
        prefill: false
      });`

      script.text = text
      // script.addEventListener("load", function () {
      //   resolve()
      //   console.log('!')
      // })
      // script.addEventListener("error", function (e) {
      //   reject(e)
      // })
      document.body.appendChild(script)

    })

  }

  handleFormChange = (form) => {
    console.log("handling form change");
    let formscript = `<script id="aoform-script-${forms[form].id}:d-0001"/>`
    document.getElementById("formBox").innerHTML = formscript

    //remove old scripts so it doesn't get too cluttered
    let prevScripts = document.getElementsByTagName("script")
    document.body.removeChild(prevScripts[prevScripts.length - 1])

    this.new_form(forms[form].id)
    this.setState({
      form: forms[form]
    })
  }

  render() {
    return (
      <Layout>
        <SEO title="Contact Us" description="Interested in learning more about cybersecurity learning and assessment solutions for your organization? Contact us to schedule a free demo."/>
        <div className="mainContainer gray" style={{padding: "60px 0"}}>
          <div className="centeredContainer">
            <div className="headerImage">
              <img src={woman}></img>
            </div>
            <div className="headerCTAs">
              <div className="titleText">
                <h2>Connect With Us</h2>
                <p>Looking for information about Circadence and Project Ares? Check out the following links and forms.</p>
              </div>
              <button className="cta-block" onClick={() => this.handleFormChange("sales")}>
                  <h4>Contact Sales</h4>
                  <p>Need help? We’re here to answer questions, demo Project Ares, and recommend the right solution for you or your organization. Contact us through the form below.</p>
              </button>
              <button className="cta-block">
                <Link to="/faq">
                  <h4>Frequently Asked Questions</h4>
                  <p>Getting started with the Project Ares learning platform? We’ve got a list of common questions on our FAQ page to help you..</p>
                </Link>
              </button>
              <button className="cta-block" onClick={() => this.handleFormChange("support")}>
                <h4>Contact Support</h4>
                <p>Already a Project Ares customer? Our Customer Support team is available to assist with questions or issues you may have. Email them through the form below.</p>
              </button>
              <button className="cta-block">
                <a target="__blank" href="https://marketing.circadence.com/acton/fs/blocks/showLandingPage/a/36273/p/p-00f8/t/page/fm/0">
                  <h4>Partner With Us</h4>
                  <p>We’re always looking for quality partners to join our mission to create a more effective cyber workforce. Learn more about our partner program.</p>
                </a>
              </button>
            </div>
          </div>
        </div>
        <div className="mainContainer" style={{paddingTop: 30}}>
          <div id="body-content" className="centeredContainer wrap">
            <div style={{flexBasis: "100%"}}>
              <h2>{this.state.form.header}</h2>
              <hr/>
            </div>
            <div id="form-content" className="basicFlex nowrap" style={{marginTop: 20}}>
              <div id="bullets-container" style={{flexGrow: 1, marginRight: 20}}>
                <h4 style={{marginBottom: 20}}>{this.state.form.tagline}</h4>
                {this.state.form.bullets.map((b) => {
                  return (<div className="inlineList"><CheckMark/><p>{b}</p></div>)
                })}
              </div>
              <div id="formBox" style={{flexGrow: 3, maxWidth: 650}}>
                {this.state.form.code}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }

}

export default ContactPage
